import { render, staticRenderFns } from "./TwoFactorSettings.vue?vue&type=template&id=c7c7a92e&scoped=true"
import script from "./TwoFactorSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoFactorSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TwoFactorSettings.vue?vue&type=style&index=0&id=c7c7a92e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c7a92e",
  null
  
)

export default component.exports